import { EvtSelect } from "components/select";
import { getDirectusField } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";
import React from "react";

const SelectType = ({
  collection,
  className,
  value,
  onChange,
  placeholder,
  ...props
}) => {
  const { data, isLoading, isError } = useFetch({
    queryKey: [collection, "type"],
    queryFn: async () => {
      const response = await getDirectusField(collection, "type");

      const data = response.meta.options.choices.map((type) => {
        return { name: type.text, id: type.value };
      });

      // Sort alphabetically by name in ascending order
      return data.sort((a, b) => {
        const nameA = (a.name || "").toLowerCase();
        const nameB = (b.name || "").toLowerCase();
        return nameA.localeCompare(nameB);
      });
    },
    enabled: !!collection,
  });

  return (
    <EvtSelect
      data={data}
      isLoading={isLoading}
      className={className}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type="filter"
      {...props}
    />
  );
};

export default SelectType;
